// extracted by mini-css-extract-plugin
module.exports = {"legend":"ChartLegend_legend__B8JlF","sensor":"ChartLegend_sensor__3hBfe","switch":"ChartLegend_switch__3lJgW"};